import React, { Fragment } from "react";
import "./BookmarkList.scss";
import { addUrlPrefix } from "../../utils/urlValidations";
import H, { headerSizes } from "../elements/H";
import A from "../elements/A";
import { withDefaults } from "../../utils/withDefaults";
import type {
  BookmarkList as BookmarkListModel,
  BookmarkListEntry
} from "../../types/models";

export interface BookmarkListProps {
  bookmarkLists?: BookmarkListModel[];
  widget_id?: string;
}

export default function BookmarkList(incomingProps: BookmarkListProps) {
  const props = withDefaults(incomingProps, bookmarkListDefaultProps);

  const bookmarkList = props.bookmarkLists.find(
    (bookmarkCategory: BookmarkListModel) =>
      bookmarkCategory.widget_id === props.widget_id
  );
  return (
    <div className="bookmark-list-container">
      {bookmarkList ? (
        <Fragment>
          <div className="bookmark-list-category">
            <H
              size={headerSizes.EXTRA_SMALL}
              textAlign="center"
              className="header-layout-font"
              usePermanentAccent={false}
            >
              {bookmarkList.category}
            </H>
          </div>
          <div className="bookmarks">
            <ul>
              {bookmarkList.bookmarks.map(
                (bookmark: BookmarkListEntry, index: number) => {
                return (
                  <li key={index}>
                    <A
                      href={addUrlPrefix(bookmark.url)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body-layout-font"
                    >
                      {bookmark.name}
                    </A>
                  </li>
                );
              })}
            </ul>
          </div>
        </Fragment>
      ) : (
        "Bookmark List is currently in edit mode"
      )}
    </div>
  );
}

const bookmarkListDefaultProps = {
  bookmarkLists: [],
  editWidgetIdentifiers: []
};
